import { useRef } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-Calendar-gui-icu.properties';

const useTextLocalizer = createUseTextLocalizer(bundle);

interface State {
  selectedDate: null | Date;
  selectedText: string;
}

const initialState = {
  selectedDate: null,
  selectedText: '',
};

const useSelectedAriaDescribedby = () => {
  const localize = useTextLocalizer();

  const state = useRef<State>(initialState);

  const getSelectedText = (day: Date, property: string) => {
    const selectedText = localize(property, {
      date: day.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
    });

    return selectedText;
  };

  const handleAriaDateSelection = (day: Date, isSelected: boolean) => {
    const selectedText = isSelected
      ? getSelectedText(day, 'notselected.date.aria')
      : getSelectedText(day, 'select.date.aria');

    state.current = {
      selectedDate: day,
      selectedText,
    };
  };

  const resetAllAriaSelected = () => {
    state.current = initialState;
  };

  return {
    ariaSelectedDate: state.current.selectedDate,
    ariaSelectedText: state.current.selectedText,
    resetAllAriaSelected,
    handleAriaDateSelection,
  };
};

export default useSelectedAriaDescribedby;
